import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const SERPSnapshotEmptyState = () => (
    <Stack
        justifyContent="center"
        alignItems="center"
        margin="100px 0 0"
    >
        <SWReactIcons iconName={"no-data-page"} />
        <Text
            fontVariant="subtitle1"
            color={colorsPalettes.carbon[500]}
        >
            {translate("serp.no.data.title")}
        </Text>
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[500]}
        >
            {translate("serp.no.data.subtitle")}
        </Text>
    </Stack>
);
